import yellowpaperDialect from '../_contract/_@schema/yellowpaper-dialect.json' with { type: 'json' };
import repositoryTreeSchema from '../_contract/_@schema/repository-tree.json' with { type: 'json' };
export { yellowpaperDialect, repositoryTreeSchema };
/** Opt-in dialect support keeps the scoped validator independent of authored schema domains. */
export const yellowpaperSchemaOptions = {
    metaSchemas: [yellowpaperDialect],
    annotationKeywordSchemas: { axioms: { type: 'array', items: { type: 'string', minLength: 1 } } },
};
